import { render, staticRenderFns } from "./RequestTickets.vue?vue&type=template&id=4241a602&scoped=true&"
import script from "./RequestTickets.vue?vue&type=script&lang=js&"
export * from "./RequestTickets.vue?vue&type=script&lang=js&"
import style0 from "./RequestTickets.vue?vue&type=style&index=0&id=4241a602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241a602",
  null
  
)

export default component.exports